import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";

const SENT_COMPONENTS = { strong: <strong className="text-primary" /> };
const HINT_COMPONENTS = { strong: <strong /> };

export const ResendSentView = ({ email }) => {
  const { t } = useTranslation();
  const sentValues = useMemo(() => ({ email }), [email]);
  return (
    <AuthLayout
      icon={CheckCircle2}
      title={t("resendSetup.sentTitle")}
      subtitle={t("resendSetup.sentSubtitle")}
      footer={
        <Link to="/login" data-testid="resend-sent-login" className="text-primary font-medium hover:underline">
          <ArrowLeft className="w-3 h-3 inline mr-1" />{t("resendSetup.backToLogin")}
        </Link>
      }
    >
      <p data-testid="resend-sent-confirmation" className="text-sm text-foreground text-center">
        <Trans i18nKey="resendSetup.sentBody" values={sentValues} components={SENT_COMPONENTS} />
      </p>
      <p className="text-sm text-muted-foreground text-center mt-3">
        <Trans i18nKey="resendSetup.sentHint" components={HINT_COMPONENTS} />
      </p>
    </AuthLayout>
  );
};
